import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
import Login from '../components/Login/Login.vue'
import ResetPassword from '../components/Login/ResetPassword.vue'

// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Admin pages
import Overview from 'src/components/Dashboard/Views/Overview.vue'
import UserProfile from 'src/components/Dashboard/Views/UserProfile.vue'
import ChatbotManagement from 'src/components/Dashboard/Views/ChatbotManagement/index.vue'
import UserManagement from 'src/components/userManagement/index.vue'
import Performance from 'src/components/Performance/index.vue'
import Reports from 'src/components/Dashboard/Views/Reports.vue'
import TableList from 'src/components/Dashboard/Views/TableList.vue'
import Maps from 'src/components/Dashboard/Views/Maps.vue'
import Typography from 'src/components/Dashboard/Views/Typography.vue'
import Icons from 'src/components/Dashboard/Views/Icons.vue'
import LeaveManagement from 'src/components/LeaveManagement'
import Settings from '../components/Dashboard/Views/Settings.vue'
import Complains from '../components/complains'
import PayrollManagement from '../components/PayrollManagement/index.vue'
import PayrollDetails  from '../components/PayrollManagement/PayrollDetails/index.vue'
import PaySlip  from '../components/PayrollManagement/Payslip/PaySlip.vue'
import Policies from 'src/components/Dashboard/Views/Policies.vue'
import AdminActivities from '../components/Dashboard/Views/AdminActivities/index.vue'
import ReportedBugs from '../components/Dashboard/Views/ReportedBugs/index.vue'

const routes = [
  {
    path: '/',
    name: "Login",
    component: Login,
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/overview'
  },
  {
    path: '/',
    component: DashboardLayout,
    name: "Dashboard",
    redirect: '/stats',
    children: [
      {
        path: 'overview',
        name: 'overview',
        component: Overview
      },
      {
        path: 'user',
        name: 'User Profile',
        component: UserProfile
      },
      {
        path: 'user/:id',
        name: 'User Profile With ID',
        component: UserProfile,
        props: true,
      },
      {
        path: 'userManagement',
        name: 'User Management',
        component: UserManagement
      },
      {
        path: 'performance',
        name: 'Performance',
        component: Performance
      },
      {
        path: 'reports',
        name: 'User Reports',
        component: Reports
      },
      {
        path: 'tables',
        name: 'Table List',
        component: TableList
      },
      {
        path: 'leave',
        name: 'Leave Management',
        component: LeaveManagement
      },
      {
        path: 'payroll',
        name: 'Payroll Management',
        component: PayrollManagement
      },
      {
        path: 'payroll/details/:employeeId',
        name: 'Payroll Details',
        component: PayrollDetails,
        props: true
      },
      {
        path: 'payroll/payslip/:employeeId',
        name: 'payslip',
        component: PaySlip
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings
      },
      {
        path: 'complains',
        name: 'Complains',
        component: Complains
      },
      {
        path: 'policies',
        name: 'Policies',
        component: Policies
      },
      {
        path: 'reported-bugs',
        name: 'Reported Bugs',
        component: ReportedBugs
      },
      {
        path: 'activity-logs',
        name: 'Admin Activities',
        component: AdminActivities
      },
      {
        path: 'chatbot',
        name: 'Chatbot Management',
        component: ChatbotManagement
      },
     
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js